import { Component, input, model, OnInit } from '@angular/core';
import { ReactiveFormsModule, AbstractControl, FormControl } from '@angular/forms';

import { DynamicFormField } from '../../../models/dynamic-form';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component( {
  selector: 'app-dynamic-field-textarea',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule],
  templateUrl: './dynamic-field-textarea.html',
  styleUrl: './dynamic-field-textarea.css'
} )
export class DynamicFieldTextarea implements OnInit
{
  public field = input.required<DynamicFormField>();
  public control = model.required<AbstractControl>();
  public formControl!: FormControl;
  public label: string = '';

  ngOnInit(): void
  {
    this.formControl = this.control() as FormControl;
  }
}
